import { render } from "./mobileswiper.vue?vue&type=template&id=600e0b28&scoped=true"
import script from "./mobileswiper.vue?vue&type=script&lang=js"
export * from "./mobileswiper.vue?vue&type=script&lang=js"

import "./mobileswiper.vue?vue&type=style&index=0&id=600e0b28&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600e0b28"]])

export default __exports__